import styled from 'styled-components';

import Desktop from './Desktop';

const StyledDesktop = styled(Desktop)`
    display: flex;
    flex-direction: column;
    
    img {
        height: 138px;
    }
`;

export default StyledDesktop;
